<template>
  <div :key="stepKey">
    <v-alert v-if="protocol.related_protocol" :value="true" color="success" type="success">
      Skjemaet er ferdig utfylt med inventar fra innflyttingsprotokoll
    </v-alert>
    <v-flex xs12>
      <h2 class="text-center mb-3">Befaring av eiendom</h2>
    </v-flex>
    <h4
      class="text-center"
    >For å unngå konflikt ved utflytting er det viktig å dokumentere forholdene i boligen. <br />Legg enkelt til bilder av mangler/feil slik at det ikke er tvil om hvordan forholdene er.</h4>
    <ImageUploadBox :images="stepValues.images" :relatedImages="stepValues.relatedImages"></ImageUploadBox>
    <v-flex xs12 class="mb-2">
      <h4 class="text-center">Her kan du fylle i eventuelle skader eller mangler ved eiendommen.</h4>
    </v-flex>
    <v-flex xs12 class="mb-3">
      <TextareaInput v-model="stepValues.comments" @update-fields="updateFields"></TextareaInput>
    </v-flex>
    <v-flex xs12 class="mb-3">
      <TextInput v-model="stepValues.textFields" @update-fields="updateFields"></TextInput>
    </v-flex>
    <StepButtons @next-page="next" @previous-page="previous" :step="this" />
  </div>
</template>

<script>
import step from "../../mixins/step";
export default {
  mixins: [step],
  data() {
    return {
      stepKey: this.getNewStepKey()
    }
  },
  mounted: function() {
    if(this.protocol.related_protocol && this.stepValues) {
      if(!this.stepValues.loadedFromRelated) {
        this.stepValues.loadedFromRelated = true
        let values = JSON.parse( JSON.stringify(this.protocol.related_protocol.steps.inspection.saved_values))
        this.stepValues.relatedImages = values.images
        for(let comment in values.comments) {
          this.stepValues.comments[comment].relatedValue = values.comments[comment].value
        }
        this.stepKey = this.getNewStepKey()
      }
    }
  },
  methods: {
    getNewStepKey() {
      return Math.floor(Math.random() * 100000000)
    }
  },
  activated() {
    this.stepKey = this.getNewStepKey()
  }
};
</script>
